
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { passwordRulesEl, usernameRuleEl } from "@common/src/utils/verify";
import t from "@common/src/i18n/t";
import ImgLoader from "@common/src/components/scope/img-loader/index.vue";
const user = namespace("user");
@Component({ components: { ImgLoader } })
export default class ForgetPwd extends Vue {
  @user.Action getMobileCode;
  @user.Action resetPassword;
  form = {
    verCode: "",
    account: "",
    password: "",
    confirmPassword: ""
  };
  showPwdTips: boolean = false;
  passPass: boolean = false;
  isServerError: boolean = false;
  changeLoading: boolean = false;
  serverErrorMsg: string = "";
  get rules() {
    return {
      account: [
        {
          required: true,
          message: t("login.username-empty-tips"),
          trigger: "blur"
        },
        { validator: this.validatUsername, trigger: "blur" }
      ],
      verCode: [
        {
          required: true,
          message: t("login.verifiCode-empty-tips"),
          trigger: "blur"
        }
      ],
      password: [{ validator: this.validatePassword, trigger: "change" }],
      confirmPassword: [
        {
          required: true,
          message: t("login.password-empty-tips"),
          trigger: "blur"
        },
        { validator: this.validateConfirm, trigger: "blur" }
      ]
    };
  }
  timer: any;
  countDownNum: number = 60;
  verificationCodeToken: string = "";
  destroyed() {
    // 优化-销毁定时器
    this.timer && clearInterval(this.timer);
  }

  validatUsername(rule, value, callback) {
    usernameRuleEl(value, callback);
  }
  validateConfirm(rule, value, callback) {
    if (value !== this.form.password) {
      callback(new Error(t("login.password-no-same") as string));
    } else {
      callback();
    }
  }
  validatePassword(rule, value, callback) {
    passwordRulesEl(value, callback);
  }
  handleValid(prop, isPass) {
    if (prop === "password") {
      if (isPass) {
        this.passPass = true;
      } else {
        this.passPass = false;
      }
    }
  }
  hasSendCode: boolean = false;
  getMesageFlag = true;
  checkMobile(refName) {
    (this.$refs[refName] as any).validateField("account", errorMessage => {
      if (!errorMessage && this.getMesageFlag) {
        this.getMesageFlag = false;
        this.getVerificationCode();
      }
    });
  }
  async getVerificationCode() {
    if (this.hasSendCode) {
      return;
    }
    this.getMobileCode({
      account: this.form.account,
      validationCodeType: "2"
    })
      .then(data => {
        this.verificationCodeToken = data.data.validationToken;
        this.hasSendCode = true;
        this.timer = setInterval(() => {
          if (--this.countDownNum === 0) {
            clearInterval(this.timer);
            this.hasSendCode = false;
            this.countDownNum = 60;
            this.getMesageFlag = true;
          }
        }, 1000);
        this.$message.success(
          t("v210906.tail-number") + data.data.mobileSuffix + t("v210906.verification-code-sent-to-mobile-phone")
        );
      })
      .catch(data => {
        this.serverErrorMsg = data.message;
        this.isServerError = true;
        this.changeLoading = false;
      });
  }
  submitForm(refName) {
    (this.$refs[refName] as any).validate(async valid => {
      if (valid) {
        this.changeLoading = true;
        this.resetPassword({
          account: this.form.account,
          password: this.form.password,
          verificationCode: this.form.verCode,
          verificationCodeToken: this.verificationCodeToken
        }).then(
          () => {
            this.$router.push("/change-success?from=reset-pwd");
          },
          data => {
            this.serverErrorMsg = data.message;
            this.isServerError = true;
            this.changeLoading = false;
          }
        );
      }
    });
  }
}
